import { makeStyles } from '@mui/styles';
import { FONT_WEIGHTS } from '../../ObeeTheme';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    width: '70px',
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.WHITE,
    borderRadius: '10px',
    fontSize: '42px',
  },
  restaurantName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...theme.typography.heading.H4,
    fontWeight: FONT_WEIGHTS.MEDIUM,
    width: '100%',
  },
  restaurantAddress: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...theme.typography.body.subText,
  },
}));

export default useStyles;
